// Dependencies
var _ = require('underscore');
var Backbone = require('backbone');

// App
var ModalFormView = require('app/common/views/modal-form-view');
var Template = require('app/utils/template');
var ContactTpl = require('./templates/contact.html');

var ContactView = ModalFormView.extend({
    className: 'modal contact-modal',
    template: Template(ContactTpl),

    initialize: function(options) {
        var contactEmail = Backbone.Model.extend({
            url: options.url,
        });

        this.model = new contactEmail({
            agent_contacts: options.contacts.pluck('id'),
        });
    },

    fields: {
        agent_contacts: {
            encoder: 'Array',
            encoderOptions: {
                arrayItemEncoder: 'Integer',
                transformFn: _.compact,
            },
            nested: 'Checkboxes',
            rules: {
                required: 'At least one email is required',
            },
        },
        email: {
            rules: ['required', 'email'],
        },
        message: 'Text',
    },

    onSubmitSuccess: function() {
        this.closeModal();
    },

    templateHelpers: function() {
        return {
            contacts: this.getOption('contacts'),
        };
    },
});

module.exports = ContactView;
